import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { hasMetrikaConsent, trackPageView } from "./metrika";

export default function MetrikaRouteTracker() {
  const location = useLocation();
  const isFirstRender = useRef(true);

  useEffect(() => {
    if (!hasMetrikaConsent()) return;

    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }

    trackPageView(location.pathname + location.search);
  }, [location.pathname, location.search]);

  return null;
}
